module.exports = __webpack_public_path__ + "static/img/tooltipActive.9fb407b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tooltipActive.png
// module id = 86
// module chunks = 1